<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2020-03-04 18:15:17
 * @LastEditTime: 2020-03-11 21:04:10
 -->
<template>
  <div
    :class="['l-btn lv-80 lv-rm-12',selfClass?selfClass:'c-btn','disb',disabled?'c-btn-disabled':'']"
    @click="clickBtn"
  >
    <slot name="left">
      <span v-if="leftIcon">
        <svg class="left-icon btn-icon">
          <use :xlink:href="leftIcon" />
        </svg>
      </span>
    </slot><!--
        --><slot /><!--
        --><slot name="right">
            <span v-if="rightIcon">
                <svg class="right-icon btn-icon">
                    <use :xlink:href="rightIcon" />
                </svg>
            </span>
        </slot>
  </div>
</template>
<script>

export default {
  props: {
    // 按钮左侧的图标
    leftIcon: {
      type: String,
      default: '',
    },
    // 按钮右侧的图标
    rightIcon: {
      type: String,
      default: '',
    },
    selfClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  created() {},
  methods: {
    clickBtn() {
      if (!this.disabled) {
        this.$emit('click')
      }
    },
  },
}
</script>
<style lang="less">
@import '~less/button.less';
.disb {
  display: inline-block;
}
.left-icon{
  margin-right: 8px;
}
.right-icon{
  margin-left: 8px;
}
</style>
